import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaYoutube, FaGithub, FaMedium, FaLinkedin, FaFileAlt, FaPaperPlane, FaBook, FaPlane, FaPaintBrush, FaBars } from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPython, faJs, faGithub, faReact, faFlutter } from '@fortawesome/free-brands-svg-icons';
import { SiLeetcode, SiFlask, SiTensorflow, SiPytorch, SiScikitlearn, SiOllama, SiGooglegemini, SiPostgresql, SiGooglecloud, SiMongodb, SiFirebase, SiBim } from 'react-icons/si';
import './App.css';

const SectionArrow = () => (
  <div className="arrow-container">
    <div className="dotted-arrow" />
  </div>
);

const GlassCard = ({ id, title, image, children }) => (
  <motion.div
    id={id}
    className="card"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
    viewport={{ once: true }}
  >
    {image && <img src={image} alt={title} className="card-image" />}
    <h2 className="section-title">{title}</h2>
    <div className="section-content">{children}</div>
  </motion.div>
);

function App() {
  const [showAllExperience, setShowAllExperience] = useState(false);
  const [showAllAchievements, setShowAllAchievements] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  const experiences = [
    {
      company: 'IBM',
      logo: 'https://pixelbag.net/wp-content/uploads/2022/01/ibm-vector-logo-download-svg.jpg',
      timePeriod: 'Jun 2024 - Present',
      position: 'Software Developer',
      location: 'Bangalore, India',
      description: [
        'Integrated webMethods.io with Automation Explorer, enhancing workflows and platform functionality',
        'Collaborated with cross-functional teams to integrate AI capabilities in Flow Editor to increase efficiency by 20%',
      ],
    },
    {
      company: 'Software AG',
      logo: 'https://logosandtypes.com/wp-content/uploads/2022/03/Software-AG.png',
      timePeriod: 'Dec 2023 - May 2024',
      position: 'Software Engineer Intern',
      location: 'Bangalore, India',
      description: [
        'Contributed to the development of webMethods.io, an integration platform as a service (iPaaS). Developed a reusable resizable panel used across 4 editor components, reducing development time by 25% and enhancing UI consistency',
        'Built a component for displaying real-time server logs in the editor, enabling developers to monitor and debug issues efficiently. This improvement reduced the average debug time by 30%',
      ],
    },
    {
      company: 'Adeptmind',
      logo: 'https://media.glassdoor.com/sqll/1692088/adeptmind-squarelogo-1538512338687.png',
      timePeriod: 'Aug 2023 - Sep 2023',
      position: 'Data Analyst Intern',
      location: 'Remote',
      description: [
        'Optimized client web pages for SEO, increasing organic traffic using Google Analytics and Snowflake for performance analysis',
        'Implemented on-page and off-page SEO strategies, resulting in improved search rankings and site visibility',
      ],
    },

    {
      company: 'PayPal',
      logo: 'https://freelogopng.com/images/all_img/1655979457paypal-logo.png',
      timePeriod: 'May 2023 - Jul 2023',
      position: 'Data Analyst Intern',
      location: 'Chennai, India',
      description: [
        'Worked on Graph Machine Learning (Graph ML) algorithms with a dataset of over 60 million records, identifying key features that were later integrated into production systems',
        'Contributed to a Natural Language Processing (NLP) classification project by performing data pre-processing, exploratory data analysis (EDA), and feature engineering',
      ],
    },

    {
      company: 'Samsung R&D Institute',
      logo: 'https://media.glassdoor.com/sqll/520007/samsung-r-and-d-institute-india-squarelogo-1535345464542.png',
      timePeriod: 'Oct 2022 - Apr 2023',
      position: 'Machine Learning Project Intern',
      location: 'Remote',
      description: [
        'Developed a web app that takes a mobile screenshot as input and returns the view-hierarchy in JSON format as output',
        'Worked on a 3-stage pipeline, which performs screen parsing, UI element detection, and generation of view hierarchy',
      ],
    },


  ];

  const achievements = [
    {
      title: 'HackFest\' 25 by ISB and Citius Tech - National Finalist(Top 10)',
      image: '/hackfest.jpg',
      description:
        'Selected as National Finalists at HackFest\'25 conducted by ISB and CitiusTech, where we showcased our app Ovacare among top teams from across India.',
    },
    {
      title: 'Speaker at Build with Databases and AI, Google',
      image: '/buildwithdatabases.jpg',
      description:
        'Speaker at Google\'s Build with Databases and AI event — Presented PantryPal on stage after winning 2nd place in the Google Build and Blog Marathon.',
    },
    {
      title: '2nd Place - Indegene Hackathon 2025',
      image: '/indegene.png',
      description:
        'Runner-Up at Indegene Hackathon 2025 (organized by Indegene and HackerEarth) - Built SolaceAI, a virtual mental health assistant offering meditation, chatbot therapy, mood tracking, voice journaling, and AI-driven recommendations.',
    },
    {
      title: '2nd Place - Build and Blog Marathon by Google',
      image: '/bnb.png',
      description:
        '2nd Place at Build and Blog Marathon (hosted by Google and Code Vipassana) - Presented PantryPal at Google Kyoto Office, a smart app offering recipe suggestions, visual inspiration, and personalized meal plans.',
    },
    {
      title: '3rd Place - HerTechQuest 3.0 by Thomson Reuters, AWS and SheLovesData',
      image: '/hertechquest.png',
      description:
        '2nd Runner-Up at HerTechQuest 3.0 Hackathon (by Thomson Reuters, She Loves Data, and AWS) - Built Octopus.AI, a productivity tool for transcribing, translating, summarizing meetings, and retrieving answers from internal documentation using AI.',
    },
    {
      title: 'Winner - CodeClash by The City University of New York and GradRight',
      image: '/codeclash.png',
      description:
        'Winner of Code Clash Mini-Hackathon (organized by The City University of New York and GradRight Inc.) - Selected as one of 25 finalists from 1000+ applicants and recognized for developing scalable and innovative solutions.',
    },
    {
      title: 'All Round Excellence Award - Dept. of Computer Science & Engineering, PSG College of Technology',
      image: '/allroundexcellence.png',
      description:
        'Awarded "All Round Excellence Award" by CSEA, PSG Tech - Recognized among 140 students for excellence in academics, co-curricular, and extracurricular activities.',
    },
    {
      title: 'Winner - Chhalaang 2.0 by Microsoft for Startups and Metamorph',
      image: '/chhalaang.png',
      description:
        'Winners at Chhalaang 2.0 Hackathon (organized by MetaMorph and Microsoft for Startups) - Developed an innovative real-time JSON/XML parsing solution for DMI Finance, leveraging Python and MongoDB to enhance data processing workflows.',
    },
    {
      title: 'Winner - Data Hacks by IIT Madras',
      image: 'https://easy-peasy.ai/cdn-cgi/image/quality=80,format=auto,width=700/https://fdczvxmwwjwpwbeeqcth.supabase.co/storage/v1/object/public/images/268c4b03-533f-4e81-aec1-0c22df466a90/60fd0cc5-9dd6-4da8-90bc-ed5be8ff3150.png',
      description:
        'Winner at DataHacks (IIT Madras) - Built a smart search solution using ML to locate nearby EV charging stations efficiently'
    },
    {
      title: '3rd Place - Code play',
      image: '/codeplay.png',
      description:
        '2nd Runner-Up at Code Play - National-level intercollege competitive programming competition hosted by NIT Hamirpur, featuring strong participation from top institutes.',
    },
    {
      title: '2nd Place - Code Naari',
      image: '/codenaari.png',
      description:
        '2nd Place at Code Naari - National-level competitive programming contest organized by NIT Hamirpur, with participation from students across India.',
    },
    {
      title: 'Shri Ram Data Championship - National Finalist (Top 9)',
      image: 'https://img.freepik.com/premium-vector/team-development-flat-illustration_418302-178.jpg',
      description:
        'Shri Ram Data Championship - National Finalist (Top 9) in a data-driven hackathon conducted by Shri Ram College of Commerce, Delhi, in collaboration with CRISIL Ltd.',
    },
    {
      title: 'Winner - Venmurasu Programming Contest',
      image: 'https://www.saphirsolution.com/wp-content/uploads/2023/05/google-ranking-factors.png',
      description:
        'Winner at Venmurasu Programming Contest - Secured 1st place for building ML and NLP solutions using IndicTrans models; organized by PSG Tech.',
    },
    {
      title: 'Catathon 2021 Special Mention Award',
      image: 'https://i0.wp.com/www.manifest.co.uk/wp-content/uploads/2017/03/Caterpillar_black.jpg?resize=1080%2C401&ssl=1',
      description:
        'Special Mention at Catathon 2021 - Earned recognition for my first ML project among 2500+ participants from all over Tamil Nadu.',
    },
    {
      title: 'Pragati Saksham Scholarship',
      image: 'https://assets.thehansindia.com/h-upload/2022/12/26/1327093-o.webp',
      description:
        'Recipient of Pragati Saksham Scholarship by AICTE (2020–2024) - Awarded for meritorious performance in academics.',
    }
  ];

  const mentorships = [
    {
      company: 'Amazon ML Summer School',
      logo: 'https://clipground.com/images/amazon-logo-square-1.png',
      timePeriod: 'Sep 2023 - Oct 2023',
      position: 'Mentee',
      location: 'Remote',
      description: [
        'Selected as one of the 3000 participants to take part in the Amazon ML Summer School from about 1 Lakh Participants',
        'Selected for the recruitment process with Amazon and cleared 2 rounds of interview',
      ],
    },
    {
      company: 'Microsoft Cyber Security Engage',
      logo: 'https://academie-enix.org/wp-content/uploads/2021/05/microsoft-office-2016-professional-plus-vollversion-deutsch-32-64-bit-5-pc_2.jpg',
      timePeriod: 'May 2022 - Jun 2022',
      position: 'Mentee',
      location: 'Remote',
      description: [
        'Selected for the MS Cybersecurity Engage 2022 Cohort, an opportunity to deepen my understanding of cybersecurity in a practical and industry-focused setting.',
        'Enhanced skills in areas such as threat analysis, risk management, and incident response.',
      ],
    }
  ];

  return (
    <div className="app">
      <header className="header">
        <div className="menu-icon" onClick={handleMenuToggle}>
          <FaBars />
        </div>
        <h1>Samyuktha M S</h1>
        <p>Software Developer • ML Enthusiast • Tech Explorer</p>
        <div className="links-row">
          <a href="https://linkedin.com/in/samyuktha-m-s" target="_blank" rel="noreferrer"><FaLinkedin /> LinkedIn</a>
          <a href="https://github.com/samyuktha-12" target="_blank" rel="noreferrer"><FaGithub /> GitHub</a>
          <a href="https://drive.google.com/file/d/1W51N3AOLuWjmim-2dG5fPt_NIqbGqBxJ/view" target="_blank" rel="noreferrer"><FaFileAlt /> Resume</a>
          <a href="https://medium.com/@samyuktha1262" target="_blank" rel="noreferrer"><FaMedium /> Medium</a>
          <a href="https://leetcode.com/u/samyuktha_12" target="_blank" rel="noreferrer"><SiLeetcode /> LeetCode</a>
          <a href="https://journals.stmjournals.com/jotea/article=2024/view=145756/" target="_blank" rel="noreferrer"><FaBook /> Research Paper</a>
          <a href="https://www.youtube.com/@samyukthamohanalagiri" target="_blank" rel="noreferrer"><FaYoutube /> YouTube</a>
        </div>
      </header>

      {menuOpen && (
        <nav className="sidebar">
          <ul>
            <li><a href="#about" onClick={handleMenuToggle}>About Me</a></li>
            <li><a href="#tech-stack" onClick={handleMenuToggle}>Tech Stack</a></li>
            <li><a href="#projects" onClick={handleMenuToggle}>Projects</a></li>
            <li><a href="#experience" onClick={handleMenuToggle}>Experience</a></li>
            <li><a href="#achievements" onClick={handleMenuToggle}>Achievements</a></li>
            <li><a href="#mentorships" onClick={handleMenuToggle}>Mentorships</a></li>
            <li><a href="#education" onClick={handleMenuToggle}>Education</a></li>
            <li><a href="#contact" onClick={handleMenuToggle}>Contact</a></li>
          </ul>
        </nav>
      )}

      <main className="main">
        <GlassCard id="about" title="About Me" image="/event1.jpg">
          <p color='#ccc'>
            Hey there - I'm <b>Samyuktha</b>. I build things that think (<i>thanks, Python</i>) and look good doing it (<i>thank you, SCSS</i>).<br /><br />
            I work at <b>IBM</b> where I blend <b>AI</b> with frontend magic — crafting tools that don't just work, but feel intuitive. My tech stack usually includes a lot of <b>React.js</b> & <b>JavaScript</b>, a bit of <b>Python</b>, and a never-ending excitement for solving complex problems that make my work feel like an adventure every day.<br /><br />
            I've built apps like <b>Solace AI</b> (<i>mental health support</i>), <b>PantryPal</b> (<i>smart kitchen buddy</i>), and <b>Ovacare</b> (<i>women's health platform</i>) - not for the sake of building, but because these things should exist.<br /><br />
            My background includes internships at <b>Samsung R&D</b>, <b>PayPal</b>, and <b>Software AG</b>, a research publication, and a streak of hackathons I joined "just for fun" and accidentally won.
            Along the way, I also led <b>GDSC</b>, a perfect crash course in soft skills and juggling chaos (and I loved every minute of it). <br /><br />
            When I'm not coding, I'm an avid traveler — not the "climb a mountain" type, but the "taste every local dish" kind. And if you're wondering, I'm not the "beach person" or "mountain person," but the <b>"Can we build that?"</b> person.<br /><br />
            <i>TL;DR</i> — I care about what I build, how it works, and how it feels.<br />
          </p>
        </GlassCard>

        <SectionArrow />

        <GlassCard id="tech-stack" title="Tech Stack">
          <div className="tech-stack-container">
            <div className="tech-stack-content">
              <div className="tech-stack-category">
                <h3>Languages & Tools</h3>
                <div className="tech-stack two-columns">
                  <span> <FontAwesomeIcon icon={faPython} /> Python</span>
                  <span> <FontAwesomeIcon icon={faJs} /> JavaScript</span>
                  <span> <FontAwesomeIcon icon={faGithub} /> Git</span>
                  <span> <FaPaperPlane /> PostMan</span>
                </div>
              </div>

              <br />

              <div className="tech-stack-category">
                <h3>Frameworks & Libraries</h3>
                <div className="tech-stack two-columns">
                  <span> <FontAwesomeIcon icon={faReact} /> React.js</span>
                  <span> <FontAwesomeIcon icon={faFlutter} /> Flutter</span>
                  <span> <SiFlask /> Flask</span>
                  <span> <SiTensorflow /> TensorFlow</span>
                  <span> <SiPytorch /> PyTorch</span>
                  <span> <SiScikitlearn /> Scikit-Learn</span>
                  <span> <SiOllama /> Transformers</span>
                </div>
              </div>

              <br />

              <div className="tech-stack-category">
                <h3>Technologies & Platforms</h3>
                <div className="tech-stack two-columns">
                  <span> <SiGooglegemini /> LLMs</span>
                  <span> RAG</span>
                  <span> CNN</span>
                  <span> REST APIs</span>
                  <span> <SiFirebase /> Firebase</span>
                  <span> <SiGooglecloud /> GCP</span>
                  <span> <SiMongodb /> Mongo DB</span>
                  <span> <SiPostgresql /> PostgreSql</span>
                </div>
              </div>
            </div>

            <div className="tech-stack-image">
              <img src="/tech_stack.gif" alt="Tech Illustration" />
            </div>
          </div>
        </GlassCard>

        <SectionArrow />

        <GlassCard id="projects" title="Projects">
          <br />
          <div className="project-gallery">
            <div className="project-card">
              <a href="https://github.com/samyuktha-12/ovacare" target="_blank" rel="noopener noreferrer" className="project-card-link">
                <img src="/ovacare.gif" alt="Project 1" />
                <h3>OvaCare</h3>
                <p>Ovacare is a Flutter-based mobile application designed to assist individuals(womens) in managing PCOS (Polycystic Ovary Syndrome). It provides AI-powered tools for health tracking, meal planning, mental well-being, and more.</p>
              </a>
            </div>
            <div className="project-card">
              <a href="https://github.com/samyuktha-12/solace_ai" target="_blank" rel="noopener noreferrer" className="project-card-link">
                <img src="/solace_ai.gif" alt="Project 2" />
                <h3>Solace AI</h3>
                <p>SolaceAI is an AI-powered mental health support application designed to provide empathetic, real-time emotional support, mood tracking, guided meditations, and crisis resources.</p>
              </a>
            </div>

            <div className="project-card">
              <a href="https://github.com/samyuktha-12/pantrypal" target="_blank" rel="noopener noreferrer" className="project-card-link">
                <img src="/pantrypal.gif" alt="Project 3" />
                <h3>PantryPal</h3>
                <p>PantryPal is a smart cooking assistant app that helps users suggest recipes based on available ingredients, create personalized meal plans, generate recipes from dish images, and manage their pantry effortlessly using voice commands or receipt scans.</p>
              </a>
            </div>

            <div className="project-card">
              <a href="https://github.com/samyuktha-12/hack4change" target="_blank" rel="noopener noreferrer" className="project-card-link">
                <img src="/lingobuddy.gif" alt="Project 3" />
                <h3>LingoBuddy</h3>
                <p>LingoBuddy bridges the gap in online education by offering multilingual learning solutions for students from vernacular backgrounds in India. It uses AI to translate English lectures into native languages with new transcripts, dubbed audio, personalized learning, and vernacular Q&A.</p>
              </a>
            </div>

            <div className="project-card">
              <a href="https://github.com/samyuktha-12/iescp" target="_blank" rel="noopener noreferrer" className="project-card-link">
                <img src="/iescp.png" alt="Project 3" />
                <h3>IESCP</h3>
                <p>The Influencer Engagement and Sponsorship Coordination Platform (IESCP) connects sponsors with influencers, enabling streamlined advertisement campaigns where sponsors can promote their products or services and influencers earn monetary benefits.</p>
              </a>
            </div>

            <div className="project-card">
              <a href="https://github.com/samyuktha-12/chalkbotx" target="_blank" rel="noopener noreferrer" className="project-card-link">
                <img src="/chalkbotx.png" alt="Project 3" />
                <h3>ChalkBotX</h3>
                <p>ChalkBotX is an intelligent chatbot designed to assist students with their academic queries. It allows students to ask questions by uploading PowerPoint presentations (PPT), PDF files, images, or scanned books, and the chatbot will provide relevant answers. This Project has been published as a Research Paper.</p>
              </a>
            </div>

          </div>
        </GlassCard>

        <SectionArrow />

        <GlassCard id="experience" title="Experience">
          <div className="timeline">
            {(showAllExperience ? experiences : experiences.slice(0, 2)).map((exp, index) => (
              <div className="timeline-item" key={index}>
                <div className="timeline-content">
                  <div className="timeline-header">
                    <div className="company-info">
                      <img src={exp.logo} alt={`${exp.company} Logo`} className="company-logo" />
                      <h3 className="company-name">{exp.company}</h3>
                    </div>
                    <span className="time-period">{exp.timePeriod}</span>
                  </div>
                  <div className="position-location">
                    <span className="position-title">{exp.position}</span>
                    <span className="location">{exp.location}</span>
                  </div>
                  <ul className="description-list">
                    {exp.description.map((desc, i) => (
                      <li key={i}>{desc}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center' }}>
            <button className="show-all-button" onClick={() => setShowAllExperience(!showAllExperience)}>
              {showAllExperience ? 'Show Less' : 'Show All'}
            </button>
          </div>
        </GlassCard>

        <SectionArrow />

        <GlassCard id="achievements" title="Achievements">
          <div className="project-gallery">
            {(showAllAchievements ? achievements : achievements.slice(0, 3)).map((ach, index) => (
              <div className="project-card" key={index}>
                <img src={ach.image} alt={ach.title} />
                <h3>{ach.title}</h3>
                <p>{ach.description}</p>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center' }}>
            <button className="show-all-button" onClick={() => setShowAllAchievements(!showAllAchievements)}>
              {showAllAchievements ? 'Show Less' : 'Show All'}
            </button>
          </div>
        </GlassCard>

        <SectionArrow />

        <GlassCard id="mentorships" title="Mentorships">
          <div className="timeline">
            {mentorships.map((exp, index) => (
              <div className="timeline-item" key={index}>
                <div className="timeline-content">
                  <div className="timeline-header">
                    <div className="company-info">
                      <img src={exp.logo} alt={`${exp.company} Logo`} className="company-logo" />
                      <h3 className="company-name">{exp.company}</h3>
                    </div>
                    <span className="time-period">{exp.timePeriod}</span>
                  </div>
                  <div className="position-location">
                    <span className="position-title">{exp.position}</span>
                    <span className="location">{exp.location}</span>
                  </div>
                  <ul className="description-list">
                    {exp.description.map((desc, i) => (
                      <li key={i}>{desc}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </GlassCard>

        <SectionArrow />

        <GlassCard id="education" title="Education">
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-content">
                <div className="timeline-header">
                  <h3 className="company-name">PSG College of Technology</h3>
                  <span className="time-period">2020 - 2024</span>
                </div>
                <div className="position-location">
                  <span className="position-title">B.E. Computer Science and Engineering</span>
                  <span className="location">CGPA: 9.49/10</span>
                </div>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-content">
                <div className="timeline-header">
                  <h3 className="company-name">Indian Institute of Technology, Madras</h3>
                  <span className="time-period">2021 - 2025</span>
                </div>
                <div className="position-location">
                  <span className="position-title">Diploma in Programming</span>
                  <span className="location">Online Degree</span>
                </div>
              </div>
            </div>
          </div>
        </GlassCard>
      </main>
      <footer id="contact" className="footer">
        <p>
          Feel free to reach out to me at <a href="mailto:samyuktha1262@gmail.com">samyuktha1262@gmail.com</a>
        </p>
      </footer>
    </div>
  );
}

export default App;
